import HttpException from './HttpException';

export default class CSRFTokenMismatchHttpException extends HttpException {
    name = 'CSRFTokenMismatchHttpException';

    constructor(response: Response, message?: string) {
        super(response, message ?? 'Exceptions.services.http.csrf_token_mismatch');
    }
}
